/**
 * Rule entity class
 */

/**
 * RuleFactory
 * returns Rule entity class
 *
 * @class RuleFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Rule} class
 *
 * @ngdoc factory
 * @name mwApp.factory:RuleFactory
 */
/* @ngInject */
export default function RuleFactory (Entity, Type, m2mMixin) {
  /* === Rule class === */

  const hasOwnProperty = Object.prototype.hasOwnProperty

  /**
   * Rule model
   *
   * @class Rule
   * @classdesc Rule model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.m2mMixin
   * @return {models.Rule} Rule entity
   */
  function Rule () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Rule.prototype = Object.create(Entity.prototype)
  Rule.prototype.constructor = Rule

  /* === Rule instance methods & fields === */

  Object.assign(Rule.prototype, {

    _rules: {
      viewNetwork: 'VIEW_NETWORK',
      createNetwork: 'CREATE_NETWORK',
      editNetwork: 'EDIT_NETWORK',
      deleteNetwork: 'DELETE_NETWORK',

      viewSearch: 'VIEW_SEARCH',
      editSearch: 'EDIT_SEARCH',
      deleteSearch: 'DELETE_SEARCH',

      viewSubscriber: 'VIEW_SUBSCRIBER',
      securitySearchSubscriber: 'SECURITY_SEARCH_SUBSCRIBER',
      limitGeneralInfoSubscriber: 'LIMIT_GENERAL_INFO_SUBSCRIBER',
      createSubscriber: 'CREATE_SUBSCRIBER',
      editSubscriber: 'EDIT_SUBSCRIBER',
      deleteSubscriber: 'DELETE_SUBSCRIBER',

      viewChannel: 'VIEW_CHANNEL',
      createChannel: 'CREATE_CHANNEL',
      editChannel: 'EDIT_CHANNEL',
      deleteChannel: 'DELETE_CHANNEL',

      viewVod: 'VIEW_VOD',
      createVod: 'CREATE_VOD',
      editVod: 'EDIT_VOD',
      deleteVod: 'DELETE_VOD',

      viewVodSeries: 'VIEW_TV_SHOW',
      createVodSeries: 'CREATE_TV_SHOW',
      editVodSeries: 'EDIT_TV_SHOW',
      deleteVodSeries: 'DELETE_TV_SHOW',

      viewCatchup: 'VIEW_CATCHUP',
      createCatchup: 'CREATE_CATCHUP',
      editCatchup: 'EDIT_CATCHUP',
      deleteCatchup: 'DELETE_CATCHUP',

      viewTvChannelCategory: 'VIEW_TV_CHANNEL_CATEGORY',
      createTvChannelCategory: 'CREATE_TV_CHANNEL_CATEGORY',
      editTvChannelCategory: 'EDIT_TV_CHANNEL_CATEGORY',
      deleteTvChannelCategory: 'DELETE_TV_CHANNEL_CATEGORY',

      viewRadioChannelCategory: 'VIEW_RADIO_CHANNEL_CATEGORY',
      createRadioChannelCategory: 'CREATE_RADIO_CHANNEL_CATEGORY',
      editRadioChannelCategory: 'EDIT_RADIO_CHANNEL_CATEGORY',
      deleteRadioChannelCategory: 'DELETE_RADIO_CHANNEL_CATEGORY',

      viewVodCategory: 'VIEW_VOD_CATEGORY',
      createVodCategory: 'CREATE_VOD_CATEGORY',
      editVodCategory: 'EDIT_VOD_CATEGORY',
      deleteVodCategory: 'DELETE_VOD_CATEGORY',

      viewTvShowCategory: 'VIEW_TV_SHOW_CATEGORY',
      createTvShowCategory: 'CREATE_TV_SHOW_CATEGORY',
      editTvShowCategory: 'EDIT_TV_SHOW_CATEGORY',
      deleteTvShowCategory: 'DELETE_TV_SHOW_CATEGORY',

      viewDevice: 'VIEW_DEVICE',
      createDevice: 'CREATE_DEVICE',
      editDevice: 'EDIT_DEVICE',
      deleteDevice: 'DELETE_DEVICE',

      viewUser: 'VIEW_USER',
      createUser: 'CREATE_USER',
      editUser: 'EDIT_USER',
      deleteUser: 'DELETE_USER',

      viewExtension: 'VIEW_EXTENSION',
      createExtension: 'CREATE_EXTENSION',
      editExtension: 'EDIT_EXTENSION',
      deleteExtension: 'DELETE_EXTENSION',

      /**
       * Payment - rules for "Organization Payment Services" (Path: Organizations - selected Organization - Payment Services)
       */
      viewNetworkPayment: 'VIEW_PAYMENT',
      // createPayment: 'CREATE_PAYMENT', // exists, but not used, so, hide from the interface
      editNetworkPayment: 'EDIT_PAYMENT',
      // deletePayment: 'DELETE_PAYMENT', // exists, but not used, so, hide from the interface

      /**
       * General - rules for "Organization Settings" (Path: Organizations - selected Organization - General - Organization Settings)
       */
      viewNetworkGeneral: 'VIEW_GENERAL',
      editNetworkGeneral: 'EDIT_GENERAL',

      /**
       * ex Payment (path: Sidebar - Settings - Payment Services - Payment Services)
       */
      viewGlobalPayment: 'VIEW_GLOBAL_PAYMENT',
      editGlobalPayment: 'EDIT_GLOBAL_PAYMENT',

      /**
       * ex General (path:)
       */
      viewGlobalGeneral: 'VIEW_GLOBAL_GENERAL',
      editGlobalGeneral: 'EDIT_GLOBAL_GENERAL',

      viewSubscription: 'VIEW_SUBSCRIPTION',
      createSubscription: 'CREATE_SUBSCRIPTION',
      editSubscription: 'EDIT_SUBSCRIPTION',
      deleteSubscription: 'DELETE_SUBSCRIPTION',

      viewAnnouncement: 'VIEW_ANNOUNCEMENT',
      createAnnouncement: 'CREATE_ANNOUNCEMENT',
      editAnnouncement: 'EDIT_ANNOUNCEMENT',
      deleteAnnouncement: 'DELETE_ANNOUNCEMENT',

      viewSubscriptionPayment: 'VIEW_SUBSCRIPTION_PAYMENT',
      createSubscriptionPayment: 'CREATE_SUBSCRIPTION_PAYMENT',
      cashPaymentSubscriptionPayment: 'CREATE_CASH_SUBSCRIPTION_PAYMENT',
      lengthAdjustmentSubscriptionPayment: 'EDIT_SUBSCRIPTION_PAYMENT_LENGTH',
      voidOrRefundSubscriptionPayment: 'VOID_OR_REFUND_SUBSCRIPTION_PAYMENT',

      viewSubscriberDevice: 'VIEW_SUBSCRIBER_DEVICE',
      editSubscriberDevice: 'EDIT_SUBSCRIBER_DEVICE',
      viewSubscriberCustomStream: 'VIEW_SUBSCRIBER_CUSTOM_STREAM',
      editSubscriberCustomStream: 'EDIT_SUBSCRIBER_CUSTOM_STREAM',
      viewSubscriberActivationCreditCard: 'VIEW_SUBSCRIBER_ACTIVATION_CREDIT_CARD',
      createSubscriberActivationCreditCard: 'CREATE_SUBSCRIBER_ACTIVATION_CREDIT_CARD',
      editSubscriberActivationCreditCard: 'EDIT_SUBSCRIBER_ACTIVATION_CREDIT_CARD',
      deleteSubscriberActivationCreditCard: 'DELETE_SUBSCRIBER_ACTIVATION_CREDIT_CARD',
      viewSubscriberNote: 'VIEW_SUBSCRIBER_NOTE',
      createSubscriberNote: 'CREATE_SUBSCRIBER_NOTE',
      editSubscriberNote: 'EDIT_SUBSCRIBER_NOTE',

      createDeviceSlot: 'CREATE_DEVICE_SLOT',
      editDeviceSlot: 'EDIT_DEVICE_SLOT',
      deleteDeviceSlot: 'DELETE_DEVICE_SLOT',

      viewNetworkCurrency: 'VIEW_NETWORK_CURRENCY',
      editNetworkCurrency: 'EDIT_NETWORK_CURRENCY',

      viewCurrency: 'VIEW_CURRENCY',
      createCurrency: 'CREATE_CURRENCY',
      editCurrency: 'EDIT_CURRENCY',
      deleteCurrency: 'DELETE_CURRENCY',

      viewDistributor: 'VIEW_DISTRIBUTOR',
      createDistributor: 'CREATE_DISTRIBUTOR',
      editDistributor: 'EDIT_DISTRIBUTOR',
      deleteDistributor: 'DELETE_DISTRIBUTOR',

      viewVoucherBatch: 'VIEW_VOUCHER_BATCH',
      createVoucherBatch: 'CREATE_VOUCHER_BATCH',
      editVoucherBatch: 'EDIT_VOUCHER_BATCH',
      deleteVoucherBatch: 'DELETE_VOUCHER_BATCH',

      // TODO: remove
      // viewReport: 'VIEW_REPORT',
      // createReport: 'CREATE_REPORT',
      // deleteReport: 'DELETE_REPORT',

      viewSubscriberReport: 'VIEW_SUBSCRIBER_REPORT',
      createSubscriberReport: 'CREATE_SUBSCRIBER_REPORT',
      deleteSubscriberReport: 'DELETE_SUBSCRIBER_REPORT',

      viewSubscriberActivityReport: 'VIEW_SUBSCRIBER_ACTIVITY_REPORT',
      createSubscriberActivityReport: 'CREATE_SUBSCRIBER_ACTIVITY_REPORT',
      deleteSubscriberActivityReport: 'DELETE_SUBSCRIBER_ACTIVITY_REPORT',

      viewCpsReport: 'VIEW_CPS_REPORT',
      createCpsReport: 'CREATE_CPS_REPORT',
      deleteCpsReport: 'DELETE_CPS_REPORT',

      viewStreamReport: 'VIEW_STREAM_REPORT',
      createStreamReport: 'CREATE_STREAM_REPORT',
      deleteStreamReport: 'DELETE_STREAM_REPORT',

      viewActivationAuditReport: 'VIEW_ACTIVATION_AUDIT_REPORT',
      createActivationAuditReport: 'CREATE_ACTIVATION_AUDIT_REPORT',
      deleteActivationAuditReport: 'DELETE_ACTIVATION_AUDIT_REPORT',

      viewFinancialReport: 'VIEW_FINANCIAL_REPORT',
      createFinancialReport: 'CREATE_FINANCIAL_REPORT',
      deleteFinancialReport: 'DELETE_FINANCIAL_REPORT',

      viewTransactionReport: 'VIEW_TRANSACTIONAL_REPORT',
      createTransactionReport: 'CREATE_TRANSACTIONAL_REPORT',
      deleteTransactionReport: 'DELETE_TRANSACTIONAL_REPORT',

      viewLiveRewind: 'VIEW_LIVE_REWIND',
      createLiveRewind: 'CREATE_LIVE_REWIND',
      editLiveRewind: 'EDIT_LIVE_REWIND',
      deleteLiveRewind: 'DELETE_LIVE_REWIND',

      viewChannelServices: 'VIEW_CHANNEL_SERVICES',
      createChannelServices: 'CREATE_CHANNEL_SERVICES',
      editChannelServices: 'EDIT_CHANNEL_SERVICES',
      deleteChannelServices: 'DELETE_CHANNEL_SERVICES',

      viewDRMAccount: 'VIEW_DRM_ACCOUNT',
      createDRMAccount: 'CREATE_DRM_ACCOUNT',
      editDRMAccount: 'EDIT_DRM_ACCOUNT',
      deleteDRMAccount: 'DELETE_DRM_ACCOUNT',

      viewDRMProfile: 'VIEW_DRM_PROFILE',
      createDRMProfile: 'CREATE_DRM_PROFILE',
      editDRMProfile: 'EDIT_DRM_PROFILE',
      deleteDRMProfile: 'DELETE_DRM_PROFILE',

      viewFeaturedCarousel: 'VIEW_FEATURED_CAROUSEL',
      createFeaturedCarousel: 'CREATE_FEATURED_CAROUSEL',
      editFeaturedCarousel: 'EDIT_FEATURED_CAROUSEL',
      deleteFeaturedCarousel: 'DELETE_FEATURED_CAROUSEL',

      viewBannerCarousel: 'VIEW_BANNER_CAROUSEL',
      createBannerCarousel: 'CREATE_BANNER_CAROUSEL',
      editBannerCarousel: 'EDIT_BANNER_CAROUSEL',
      deleteBannerCarousel: 'DELETE_BANNER_CAROUSEL',

      viewBannerFeatured: 'VIEW_BANNER_FEATURED',
      createBannerFeatured: 'CREATE_BANNER_FEATURED',
      editBannerFeatured: 'EDIT_BANNER_FEATURED',
      deleteBannerFeatured: 'DELETE_BANNER_FEATURED',

      viewGeoBlocking: 'VIEW_GEO_BLOCKING',
      createGeoBlocking: 'CREATE_GEO_BLOCKING',
      editGeoBlocking: 'EDIT_GEO_BLOCKING',
      deleteGeoBlocking: 'DELETE_GEO_BLOCKING',

      viewEpgTask: 'VIEW_EPG_TASK',
      createEpgTask: 'CREATE_EPG_TASK',
      editEpgTask: 'EDIT_EPG_TASK',
      deleteEpgTask: 'DELETE_EPG_TASK',

      viewDashboard: 'VIEW_DASHBOARD',
      editDashboard: 'EDIT_DASHBOARD',

      viewLiveEvent: 'VIEW_LIVE_EVENT',
      createLiveEvent: 'CREATE_LIVE_EVENT',
      editLiveEvent: 'EDIT_LIVE_EVENT',
      deleteLiveEvent: 'DELETE_LIVE_EVENT',

      viewLocalization: 'VIEW_I18N_LANGUAGE',
      createLocalization: 'CREATE_I18N_LANGUAGE',
      editLocalization: 'EDIT_I18N_LANGUAGE',
      deleteLocalization: 'DELETE_I18N_LANGUAGE',

      viewStreamService: 'VIEW_STREAMS',
      editStreamService: 'EDIT_STREAMS',

      viewSetrixSettings: 'VIEW_CONTENT_DELIVERY_SERVER',
      editSetrixSettings: 'EDIT_CONTENT_DELIVERY_SERVER',
      deleteSetrixSettings: 'DELETE_CONTENT_DELIVERY_SERVER',

      viewTranscoder: 'VIEW_CONTENT_DELIVERY_SERVER',
      createTranscoder: 'CREATE_CONTENT_DELIVERY_SERVER',
      modifyAssignmentTranscoder: 'ASSIGN_CONTENT_DELIVERY_SERVER',
      runtimeControlTranscoder: 'CONTROL_CONTENT_DELIVERY_SERVER',
      viewUrlPolicy: 'VIEW_STREAM_POLICY',
      createUrlPolicy: 'CREATE_STREAM_POLICY',
      editUrlPolicy: 'EDIT_STREAM_POLICY',
      deleteUrlPolicy: 'DELETE_STREAM_POLICY',

      viewAPIAccess: 'VIEW_API_ACCESS',
      editAPIAccess: 'EDIT_API_ACCESS',

      viewAPIAccessGlobal: 'VIEW_GLOBAL_API_ACCESS',
      createAPIAccessGlobal: 'CREATE_GLOBAL_API_ACCESS',
      editAPIAccessGlobal: 'EDIT_GLOBAL_API_ACCESS',
      deleteAPIAccessGlobal: 'DELETE_GLOBAL_API_ACCESS',

      viewShoppingCart: 'VIEW_SHOPPING_CART',
      editShoppingCart: 'EDIT_SHOPPING_CART',

      viewMultiorgSettings: 'VIEW_MULTIORG_SETTINGS',
      editMultiorgSettings: 'EDIT_MULTIORG_SETTINGS',

      viewAppsSettings: 'VIEW_APPS_SETTINGS',
      editAppsSettings: 'EDIT_APPS_SETTINGS',
      deleteAppsSettings: 'DELETE_APPS_SETTINGS',

      viewSubscriberLibrary: 'VIEW_SUBSCRIBER_LIBRARY',
      editSubscriberLibrary: 'EDIT_SUBSCRIBER_LIBRARY',

      viewDiscountCampaigns: 'VIEW_DISCOUNT_CAMPAIGN',
      createDiscountCampaigns: 'CREATE_DISCOUNT_CAMPAIGN',
      editDiscountCampaigns: 'EDIT_DISCOUNT_CAMPAIGN',
      deleteDiscountCampaigns: 'DELETE_DISCOUNT_CAMPAIGN'

    },

    _ruleRE: /^(view|create|edit|delete|hide|securitySearch|limitGeneralInfo|cashPayment|lengthAdjustment|voidOrRefund|modifyAssignment|runtimeControl)/,

    /**
     * instance fields
     *
     * @memberof models.Rule#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      networks: [], // default format from server: { id: Number, name: String }
      authorityTypes: [String],
      packageNames: [String],
      authenticated: true, // auxiliary field
      superAdmin: false // auxiliary field
      // all other flags added dynamically via overriden _copy() method
      // all original fields, starts with view|create|edit|delete|hide are treated as boolean flags
    },

    /**
     * url template
     *
     * @memberof models.Rule#
     * @type {String}
     */
    _urlTemplate: 'api/rules/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.Rule#
     * @type {String}
     */
    _publicUrlTemplate: 'systemusers/{{::id ? "rules/" : "#rules"}}{{::id}}',

    /**
     * Prepare rule
     *
     * @memberof models.Rule#
     * @override
     */
    _prepare: function () {
      validateKeysParity(this)
      if (this.id) {
        if (this.viewBannerCarousel || this.viewFeaturedCarousel) {
          this.viewBannerFeatured = true
        }
        if (this.createBannerCarousel || this.createFeaturedCarousel) {
          this.createBannerFeatured = true
        }
        if (this.editBannerCarousel || this.editFeaturedCarousel) {
          this.editBannerFeatured = true
        }
        if (this.deleteBannerCarousel || this.deleteFeaturedCarousel) {
          this.deleteBannerFeatured = true
        }
      }
    },

    /**
     * Dynamically add all fields with first got object
     *
     * @protected
     * @memberof models.Rule~
     * @param {Object} obj - object to copy
     * @override
     */
    _copy: function (obj) {
      // create local fields from original fields, started with view|create|edit|delete|hide, and treat them as boolean flags
      if (obj && obj.id !== undefined) {
        let f
        // add new fields to model
        for (f in Rule.prototype._rules) {
          if (hasOwnProperty.call(Rule.prototype._rules, f)) {
            Rule.prototype._fields[f] = (hasOwnProperty.call(obj, 'authorityTypes') && obj.authorityTypes.indexOf(Rule.prototype._rules[f]) !== -1)
          }
        }

        // remove old fields from model
        for (f in Rule.prototype._rules) {
          if (hasOwnProperty.call(Rule.prototype._rules, f)) {
            if (!hasOwnProperty.call(obj, 'authorityTypes')) {
              delete Rule.prototype._fields[f]
            }
          }
        }
      } else {
        let f
        for (f in Rule.prototype._rules) {
          Rule.prototype._fields[f] = false
        }
      }

      // call parent _copy
      Entity.prototype._copy.apply(this, arguments)
    },

    /**
     * Get underlying object
     *
     * @memberof models.Rule~
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      var ret = Entity.prototype._object.apply(this, arguments)
      delete ret.authenticated // remove auxiliary field
      delete ret.superAdmin // remove auxiliary field

      if (!ret.authorityTypes) {
        ret.authorityTypes = []
      }

      for (var f in ret) {
        if (this._ruleRE.test(f)) {
          if (ret[f] && hasOwnProperty.call(Rule.prototype._rules, f)) {
            ret.authorityTypes.push(Rule.prototype._rules[f])
          } else {
            const index = ret.authorityTypes.findIndex((v) => v === Rule.prototype._rules[f])
            if (index !== -1) {
              ret.authorityTypes.splice(index, 1)
            }
          }
          delete ret[f]
        }
      }
      return ret
    },

    /**
     * Expanse plain rule's boolean flags to normal array with objects
     *
     * @memberof models.Rule#
     * @param {Object[]} view - array with objects structure
     */
    _expanse: function (view) {
      // disable editing and removing packages if user has package permissions
      if (this.networks.length) {
        this.deleteNetwork = false
      }

      var actions = ['view', 'create', 'edit', 'delete', 'hide', 'securitySearch', 'limitGeneralInfo', 'cashPayment', 'lengthAdjustment', 'voidOrRefund']
      for (var i = 0; i < view.length; i++) {
        var v = view[i]
        if (v.key) {
          for (var j = 0; j < actions.length; j++) {
            if (this[actions[j] + v.key] !== undefined) {
              v[actions[j]] = !!this[actions[j] + v.key]
            }
          }
          if (v.key === 'Transcoder') {
            if (this.modifyAssignmentTranscoder !== undefined) {
              v.modifyAssignment = !!this.modifyAssignmentTranscoder
            }
            if (this.runtimeControlTranscoder !== undefined) {
              v.runtimeControl = !!this.runtimeControlTranscoder
            }
          }
          // add method to check flags parity
          v.checkParity = checkParity
        }
        if (v.children && v.children.length) {
          if (v.view) {
            v.open = true // Remove this line if don't want parent categories to be expanded
          }

          this._expanse(v.children)
        }
      }
    },

    /**
     * Reduction of normal array with objects to plain rule's boolean flags
     *
     * @memberof models.Rule#
     * @param {Object[]} view - array with objects structure
     * @param submitRules
     * @return {models.Rule} this object
     */
    _reduction: function (view, submitRules = false) {
      var actions = ['view', 'create', 'edit', 'delete', 'hide', 'securitySearch', 'limitGeneralInfo', 'cashPayment', 'lengthAdjustment', 'voidOrRefund']
      for (var i = 0; i < view.length; i++) {
        var v = view[i]
        if (v.key) {
          for (var j = 0; j < actions.length; j++) {
            if (this[actions[j] + v.key] !== undefined) {
              this[actions[j] + v.key] = !!v[actions[j]]
            }
          }
          if (v.key === 'Transcoder') {
            if (this.modifyAssignmentTranscoder !== undefined && v.modifyAssignment !== undefined) {
              this.modifyAssignmentTranscoder = !!v.modifyAssignment
            }
            if (this.runtimeControlTranscoder !== undefined && v.runtimeControl !== undefined) {
              this.runtimeControlTranscoder = !!v.runtimeControl
            }
          }
        }
        if (v.children && v.children.length) {
          this._reduction(v.children, submitRules)
        }
      }

      // disable editing and removing packages if user has package permissions
      if (this.networks.length) {
        this.deleteNetwork = false
      }
      if (submitRules && view.find(v => v.key === 'BannerFeatured')) {
        this.viewBannerCarousel = this.viewFeaturedCarousel = this.viewBannerFeatured
        this.createBannerCarousel = this.createFeaturedCarousel = this.createBannerFeatured
        this.editBannerCarousel = this.editFeaturedCarousel = this.editBannerFeatured
        this.deleteBannerCarousel = this.deleteFeaturedCarousel = this.deleteBannerFeatured
        delete this.viewBannerFeatured
        delete this.createBannerFeatured
        delete this.editBannerFeatured
        delete this.deleteBannerFeatured
      }
      return this
    }

  }, m2mMixin('networks'))

  /* === Rule static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(Rule, Entity)
  Rule._name = 'Rule'
  Rule.init()

  // permissions
  Rule.access = {
    view: 'viewUser',
    create: 'createUser',
    edit: 'editUser',
    delete: 'deleteUser'
  }

  return Rule

  /* === Private helper functions === */

  /**
   * Check parity of fields
   * For example, if flag 'view' is checked -> should uncheck 'hide' flag, and so on
   *
   * @private
   * @memberof mwApp.factory:RuleFactory
   * @param {String} flag - flag, that was changed
   */
  function checkParity (flag) {
    // this means rule here, because we add this function as a method to rule
    var rule = this

    switch (flag + '_' + rule[flag]) {
      case 'edit_false':
        rule.delete = rule.delete === undefined ? undefined : false
        rule.limitGeneralInfo = rule.limitGeneralInfo === undefined ? undefined : false
        rule.open = rule.children
        break
      case 'create_false':
        rule.cashPayment = rule.cashPayment === undefined ? undefined : false
        rule.lengthAdjustment = rule.lengthAdjustment === undefined ? undefined : false
        rule.open = rule.children
        break
      /* falls through */
      case 'cashPayment_true':
      case 'lengthAdjustment_true':
        rule.create = rule.create === undefined ? undefined : true
      case 'securitySearch_true':
        rule.view = rule.view === undefined ? undefined : true
        rule.hide = false
        break
      case 'limitGeneralInfo_true':
        rule.view = rule.view === undefined ? undefined : true
        rule.edit = rule.edit === undefined ? undefined : true
        rule.hide = false
        rule.open = rule.children
        break
      case 'limitGeneralInfo_false':
        // Don't modify view permission when limitGeneralInfo is disabled
        rule.hide = false
        rule.open = rule.children
        break
      case 'voidOrRefund_true':
        rule.view = rule.view === undefined ? undefined : true
        rule.edit = rule.edit === undefined ? undefined : true
        rule.hide = false
        break
      case 'delete_true':
        rule.edit = rule.edit === undefined ? undefined : true
      case 'runtimeControl_true':
      case 'create_true':
      case 'edit_true':
      case 'modifyAssignment_true':
      case 'view_true':
      case 'hide_false':
        rule.view = rule.view === undefined ? undefined : true
        rule.hide = false
        rule.open = rule.children
        break
      case 'hide_true':
      case 'view_false':
        rule.view = rule.view === undefined ? undefined : false
        rule.create = rule.create === undefined ? undefined : false
        rule.edit = rule.edit === undefined ? undefined : false
        rule.delete = rule.delete === undefined ? undefined : false
        rule.modifyAssignment = rule.modifyAssignment === undefined ? undefined : false
        rule.runtimeControl = rule.runtimeControl === undefined ? undefined : false
        rule.selectSearch = rule.selectSearch === undefined ? undefined : false
        rule.securitySearch = rule.securitySearch === undefined ? undefined : false
        rule.limitGeneralInfo = rule.limitGeneralInfo === undefined ? undefined : false
        rule.cashPayment = rule.cashPayment === undefined ? undefined : false
        rule.voidOrRefund = rule.voidOrRefund === undefined ? undefined : false
        rule.lengthAdjustment = rule.lengthAdjustment === undefined ? undefined : false
        rule.hide = true
        rule.open = false
        break
      default:
        rule.open = rule.children
    }
  }

  /**
   * Validate keys parity
   *
   * @param  {Rule} rule
   */
  function validateKeysParity (rule) {
    var keys = []
    var k

    // collect rule keys
    for (var f in rule) {
      if (hasOwnProperty.call(rule, f) && Rule.prototype._ruleRE.test(f)) {
        keys.push(f.replace(Rule.prototype._ruleRE, ''))
      }
    }

    // validate keys parity
    for (var i = keys.length; i--;) {
      k = keys[i]
      if (!(rule['view' + k] ||
        rule['create' + k] ||
        rule['edit' + k] ||
        rule['delete' + k] ||
        rule['modifyAssignment' + k] ||
        rule['runtimeControl' + k] ||
        rule['securitySearch' + k] ||
        rule['cashPayment' + k] ||
        rule['voidOrRefund' + k] ||
        rule['lengthAdjustment' + k])
      ) {
        rule['hide' + k] = true
      } else {
        rule['hide' + k] = false
        rule['view' + k] = rule['view' + k] === undefined ? undefined : true
      }
    }
  }
}
